export default [
  {
    path: '/research',
    component: () => import('@/components/layouts/research-layout.vue'),
    meta: { title: 'Research', authenticated: true },
    children: [
      {
        name: 'research#overview',
        path: '',
        meta: { title: 'Overview' },
        component: () => import('@/views/research/overview-view.vue'),
      },
      {
        name: 'research#chains',
        path: 'chains',
        meta: { title: 'Chains' },
        component: () => import('@/views/research/chains-view.vue'),
      },
    ],
  },
];
